import { BaseCarouselTracking } from './BaseCarouselTracking';

export class CollectionHubCarouselTracking extends BaseCarouselTracking {
    aalink = [];
    fathom = [];
    element = null;
    carousel_num = 0;
    link = null;
    url = '';
    constructor(aalink, fathom, elem, num, link) {
        super(aalink, fathom, elem, num, link);
        this.aalink = aalink;
        this.fathom = fathom;
        this.element = elem;
        this.carousel_num = num;
        this.link = link;
        this.url = link.getAttribute('href');
    }
    parse() {
        let isMovie = this.fathom.includes('movie') || this.aalink[4] === 'isMovie';
        let _carousel = this.element;
        let tTitle = _carousel.querySelector('.video-section-title')?.textContent; //?.trim();
        let _isMovieTrailer =
            typeof this.aalink[6] !== 'undefined' &&
            this.aalink[6] !== '' &&
            Number(this.aalink[6]) !== 'NaN'
                ? false
                : true;
        _isMovieTrailer = this.aalink[6] === '' ? false : _isMovieTrailer;
        _isMovieTrailer = this.aalink[11] === '-1' ? true : _isMovieTrailer;
        const cleanTitle = tTitle.trim();
        let pageName =
            typeof collectionPageName === 'undefined' ? utag_data.pageName : collectionPageName;
        let obj;

        const newBadge = this.link?.querySelector('.new-item')?.textContent;

        if (newBadge) {
            obj = { contentBadgeLabel: newBadge };
        }

        if (isMovie || _isMovieTrailer) {
            obj = {
                ...obj,
                contentBrand: this.aalink[10] || utag_data.contentBrand,
                ctaText: this.aalink[2],
                posColNum: Number(this.fathom[2]).toString(),
                posRowNum: this.carousel_num.toString(),
                movieId: this.aalink[16] ? this.aalink[16] : this.aalink[2],
                movieTitle: this.aalink[5] ? this.aalink[5] : this.aalink[1],
                movieGenre: this.aalink[15],
                rowHeaderTitle: unescape(tTitle.trim()),
                targetURL: this.url,
                targetType: this.aalink[4] + '|' + this.url,
                contentLocked: this.aalink[23] === '' ? '0' : this.aalink[23],
                showAirDate: null,
                showGenre: null,
                showSeriesId: null,
                showTitle: null,
                showSeriesTitle: null,
                showEpisodeLabel: null,
                showSeasonNumber: null,
                showEpisodeNumber: null,
            };
        } else if (this.aalink[4] === 'videoCarousel') {
            obj = {
                contentBrand: this.aalink[10] !== '' ? this.aalink[10] : 'na',
                ctaText: this.aalink[2],
                posColNum: Number(this.aalink[3]).toString(),
                posRowNum: this.carousel_num.toString(),
                showAirDate: this.aalink[8],
                showSeriesId: this.aalink[11],
                showGenre: this.aalink[15],
                showTitle: this.aalink[19],
                showSeriesTitle: this.aalink[19],
                showEpisodeId: this.aalink[20],
                rowHeaderTitle: unescape(cleanTitle),
                showEpisodeTitle: this.aalink[18],
                showEpisodeLabel: this.aalink[18],
                showSeasonNumber: this.aalink[6],
                showEpisodeNumber: this.aalink[7] !== '' ? this.aalink[7] : 'na',
                contentLocked: this.aalink[23] === '' ? '0' : this.aalink[23],
            };
        } else {
            let _contentBrand = this.aalink[12] !== '' ? this.aalink[12] : this.aalink[7];
            _contentBrand = _contentBrand === '' ? utag_data.contentBrand : _contentBrand;
            let _showSeriesId = this.aalink[13] === '' ? this.aalink[2] : this.aalink[13];
            let _showSeriesTitle = this.aalink[5] === '' ? this.aalink[1] : this.aalink[5];
            let _posColNum =
                Number(this.aalink[3]).toString() === 'NaN'
                    ? this.fathom[2]
                    : Number(this.aalink[3]).toString();
            obj = {
                ...obj,
                contentBrand: _contentBrand.toString(),
                ctaText: this.aalink[4],
                pageType: utag_data.pageType,
                posColNum: _posColNum,
                posRowNum: this.carousel_num.toString(),
                showAirDate: this.aalink[10] || 'na',
                showEpisodeId: this.aalink[18] || 'na',
                showEpisodeLabel: this.aalink[5] || 'na', //TODO
                //because passing 0 as a number and not a string is not passing, is erasing that variable. This is tracking.
                showEpisodeNumber: this.aalink[9] === '' ? 0 : this.aalink[9],
                showGenre: this.aalink[17] === '' ? 'na' : this.aalink[17],
                showDaypart: this.aalink[14] || 'na',
                showSeriesId: _showSeriesId.toString(),
                showTitle: this.aalink[5] ?? this.aalink[1],
                //because if it hasn't got a showEpisodeNumber then it is a trailer and we don't show this.
                showSeasonNumber: this.aalink[9] === '' ? 0 : this.aalink[8],
                showSeriesTitle: _showSeriesTitle,
                rowHeaderTitle: unescape(tTitle.trim()),
                targetURL: this.url,
                targetType: this.aalink[2] + '|' + this.url,
                contentLocked: this.aalink[23] === '' ? '0' : this.aalink[23],
            };
        }

        let extraParams = {
            carouselId: this.aalink[24] ?? '',
            carouselContentType: this.aalink[25] ?? '',
            carouselModel: this.aalink[26] ?? '',
            carouselPresentationStyle: this.aalink[27] ?? '',
            carouselItemTotal: this.aalink[28] ?? '',
            promoSpotTitle: this.aalink[29] ?? '',
            hubId: __hub.id ?? utag_data.hubId,
            hubSlug: __hub.hubSlug ?? utag_data.hubSlug,
            hubPageType: __hub.hubPageType ?? utag_data.hubPageType,
            pageType: __hub.pageType ?? utag_data.pageType,
            pageName: pageName,
            screenName: utag_data.screenName,
            carouselLink: this.url,
        };
        //Add tracking variants when hub collection carousel is used in search page
        if (extraParams.hubPageType === 'pre_search') {
            extraParams.searchEventComplete = '1';
            extraParams.suggestedSearchTerm = __hub.presearchSuggestionSelected;
        }

        obj = { ...obj, ...extraParams };
        window.localStorage.setItem('metadata-video-tracking', JSON.stringify(obj));

        try {
            let actionTrigger =
                typeof this.aalink[30] === 'undefined' ? 'trackHubRowHeader' : this.aalink[30];
            //Add tracking variants when hub collection carousel is used in search page
            if (extraParams.hubPageType === 'pre_search') {
                actionTrigger = 'trackSearchResult';
            }
            super.trackAction(actionTrigger, obj);

            if (
                typeof collectionDefault !== 'undefined' &&
                collectionDefault &&
                typeof om != 'undefined'
            ) {
                om.trackState({
                    hubId: __hub.id ?? utag_data.hubId,
                    hubSlug: __hub.hubSlug ?? utag_data.hubSlug,
                    hubPageType: __hub.hubPageType ?? utag_data.hubPageType,
                    pageName: collectionPageName ?? utag_data.pageName,
                    pageType: __hub.pageType ?? utag_data.pageType,
                });
            }
        } catch (e) {
            console.error(`${actionTrigger} failed to load`, e);
        }
        return false;
    }
}
